import '../../css/style.scss'
import {EntryShared} from '../../../shared/scripts/EntryShared.ts'
import {UIRulebookController} from '../../../shared/scripts/ui_rulebook/UIRulebookController.ts'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared.ts'
import {RulebookStyle} from '../../../../shared/enums/RulebookEnums.ts'

void init()

async function init() {
    const fullscreen = window['rulebookStyle'] == RulebookStyle.Fullscreen
    if(fullscreen) {
        await EntryShared.initializeEntry()
    }

    new UIRulebookController()

    if(fullscreen) {
        EntrySingletonPageShared.initializeSocketAndGeneralServices(undefined)
    }
    EntryShared.sendPageVisitAnalyticEvent()
}
